import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller('IssueFormTermController', IssueFormTermController);

    function IssueFormTermController(
        CompanyFactory,
        CompaniesFactory,
        $state,
        $stateParams,
        toastr,
        ngDialog
    ) {
        var vm = this;

        init();

        function init() {
            vm.timePickerOptions = {
                step: 30,
                timeFormat: 'H:i',
            };

            // props for storing values combined from separate date and time ng-models
            vm.combinedStartDateTime = null;
            vm.combinedEndDateTime = null;

            // date picker's ng-model
            vm.startDate = null;
            vm.endDate = null;

            // time picker's ng-model
            vm.startTime = null;
            vm.endTime = null;

            vm.handleStartDateChange = handleStartDateChange;
            vm.handleStartTimeChange = handleStartTimeChange;

            vm.sendDataToBackend = sendDataToBackend;

            fetchCurrentData().then(function() {
                // setup date picker's ng-model
                vm.startDate = formatDate(vm.combinedStartDateTime);
                vm.endDate = formatDate(vm.combinedEndDateTime);

                // setup time picker's ng-model
                vm.startTime = new Date(vm.combinedStartDateTime);
                vm.endTime = new Date(vm.combinedEndDateTime);
            });
        }

        function fetchCurrentData() {
            return CompanyFactory.readCompany().then(function (employeeData) {
                return employeeData.data.organization.party_uuid;
            }).then(function (companyId) {
                return CompaniesFactory.readOneIssue(companyId, $stateParams.issue_id);
            }).then(function (response) {
                if (response.data.realization_date_from) {
                    vm.combinedStartDateTime = new Date(response.data.realization_date_from);
                    vm.combinedEndDateTime = new Date(response.data.realization_date_to);
                } else {
                    vm.combinedStartDateTime = new Date();
                    vm.combinedEndDateTime = new Date();

                    // Setup 1-hour slot starting from the nearest half-hour.
                    var minutes = vm.combinedStartDateTime.getMinutes() < 30 ? 30 : 0;
                    var startHour = vm.combinedStartDateTime.getHours() + (minutes === 30 ? 0 : 1);
                    vm.combinedStartDateTime.setHours(startHour)
                    vm.combinedStartDateTime.setMinutes(minutes);
                    vm.combinedStartDateTime.setSeconds(0);
                    vm.combinedEndDateTime.setHours(startHour + 1);
                    vm.combinedEndDateTime.setMinutes(minutes);
                    vm.combinedEndDateTime.setSeconds(0);
                }
            });
        }

        function handleStartDateChange() {
            vm.endDate = vm.startDate;
        }

        function handleStartTimeChange() {
            if (vm.startTime !== undefined) {
                vm.endTime.setTime(vm.startTime.getTime() + 3600 * 1000);
            }
        }

        function sendDataToBackend() {
            combineDateTime();

            var data = {
                realization_date_from: vm.combinedStartDateTime,
                realization_date_to: vm.combinedEndDateTime,
            };

            CompanyFactory.readCompany().then(function (comp_id) {
                CompaniesFactory.editIssue(
                    comp_id.data.organization.party_uuid,
                    $stateParams.issue_id,
                    data
                ).then(function () {
                    toastr.success('Zapisano zmiany');
                    ngDialog.close();
                    $state.reload('company_employee.issue_list.details');
                }).catch(function (response) {
                    for (var key in response.data) {
                        var value = response.data[key];
                        value.forEach(function (element, index, array) {
                            toastr.error(value[index]);
                        });
                    }
                });
            });
        }

        function combineDateTime() {
            var combinedStartDateTime = new Date(vm.startDate);
            combinedStartDateTime.setHours(vm.startTime.getHours());
            combinedStartDateTime.setMinutes(vm.startTime.getMinutes());

            var combinedEndDateTime = new Date(vm.endDate);
            combinedEndDateTime.setHours(vm.endTime.getHours());
            combinedEndDateTime.setMinutes(vm.endTime.getMinutes());

            vm.combinedStartDateTime = combinedStartDateTime;
            vm.combinedEndDateTime = combinedEndDateTime;
        }

        function formatDate(date) {
            var day = date.getDate();
            var monthIndex = date.getMonth() + 1;
            var year = date.getFullYear();

            return year + '-' + monthIndex + '-' + day;
        }
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/issues/company_issue_list/details/term_dialog/term.controller.ts